/**
 * Actions for Gel Predictions
 *
 * This file contains action creators related to the management of gel predictions.
 * Action creators are functions that create and return action objects to be dispatched to the Redux store.
 */

/**
 * Action Creator: setGelPrediction
 *
 * Description:
 * Sets the gel prediction data in the store.
 *
 * @param {object} data - The gel prediction data.
 * @returns {object} - The action object with type and payload.
 */
export const setGelPrediction = (data) => {
  return { type: "SET_GEL_PREDICTION", payload: data };
};
